<template>
<div class="goodsEdit">
    <bbGoodsEdit :hostroletype="hostroletype"></bbGoodsEdit>
</div>
</template>

<script>
import BbGoodsEdit from 'views/brandBusiness/systemSetting/goodsBack/GoodsEdit.vue'

export default {
    name: 'goodsEdit',
    props: ['hostroletype'],
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        BbGoodsEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.goodsEdit {
}
</style>
